// extracted by mini-css-extract-plugin
export default {"no-data-cloud-invoice":"Map_no-data-cloud-invoice__5SJ-b","table-height-adjustment":"Map_table-height-adjustment__Gvd9n"};